import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DetailView from "../../components/details/DetailView";
import {
  fetchBlogById,
  updateBlog,
  deleteBlog,
  clearDetail as clearBlogDetail,
} from "../../redux/slices/blogsCommunitySlice";

export default function BlogsCommunityInfo() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { detail: blog, detailStatus, error } = useSelector(
    (s) => s.blogsCommunity
  );

  // Fetch blog by ID
  useEffect(() => {
    if (id) dispatch(fetchBlogById(id));
    return () => dispatch(clearBlogDetail());
  }, [dispatch, id]);

  if (detailStatus === "loading")
    return <div className="px-20 pt-10">Loading …</div>;
  if (detailStatus === "failed")
    return <div className="px-20 pt-10">Failed to load blog. {error}</div>;
  if (!blog) return <div className="px-20 pt-10">Blog not found.</div>;

  // Handlers
  const handleDelete = () => {
    dispatch(deleteBlog(id));
    navigate(-1); // go back after deletion
  };

  const handleEdit = () => {
    navigate(`/swift-app/admin/blogs/${id}/edit`);
  };

  const handleSave = async (formData) => {
    try {
      await dispatch(updateBlog({ id, data: formData }));
      // Optionally show success message or refetch data
    } catch (error) {
      console.error('Failed to update blog:', error);
      // Optionally show error message
    }
  };

  return (
    <DetailView
      title="Blogs and Article"
      type="blog"
      data={blog}
      onDelete={handleDelete}
      onEdit={handleEdit}
      onSave={handleSave}
    />
  );
}
